// todo: remove these utils once we're done migrating from local permissions to api permissions
import { APIPermission, APIPermissionList, IPortalUser, Permission } from '../services';

export const isAPIPermission = (permission: string): permission is APIPermission =>
    APIPermissionList.includes(permission as any);

export function checkUserPermission(permission: Permission | APIPermission, user: IPortalUser) {
    if (isAPIPermission(permission)) {
        return user.apiPermissions.has(permission);
    }

    return user.permissions.has(permission);
}

